export default __webpack_public_path__ + "static/media/give_kids.21bab20b.png";